import React from 'react';
import { Navigation } from '../components/Navigation';
import { ProofSection } from '../components/ProofSection';
import { ContactHero } from './contact/ContactHero';
import { ContactScheduleBanner } from './contact/ContactScheduleBanner';
import { ContactForm } from './contact/ContactForm';
import { Link } from 'react-router-dom';
export function ContactPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-423">
      <Navigation data-id="element-424" />
      <ContactHero data-id="element-425" />
      <ContactScheduleBanner data-id="element-426" />
      <ContactForm data-id="element-427" />
      <ProofSection testimonialIndex={3} data-id="element-428" />

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm border-t-2 border-[#a3d977]/20" data-id="element-429">
        <div className="max-w-4xl mx-auto" data-id="element-430">
          <div className="font-black text-xl text-white mb-4 tracking-tighter" data-id="element-431">
            NWBBA
          </div>
          <p className="mb-6" data-id="element-432">Northwest Black Belt Academy</p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-8" data-id="element-433">
            <Link to="/" className="hover:text-[#a3d977] transition-colors" data-id="element-434">
              Home
            </Link>
            <Link to="/about" className="hover:text-[#a3d977] transition-colors" data-id="element-435">
              About
            </Link>
            <Link to="/classes" className="hover:text-[#a3d977] transition-colors" data-id="element-436">
              Classes
            </Link>
            <Link to="/schedule" className="hover:text-[#a3d977] transition-colors" data-id="element-437">
              Schedule
            </Link>
            <Link to="/resources" className="hover:text-[#a3d977] transition-colors" data-id="element-438">
              Resources
            </Link>
            <Link to="/blog" className="hover:text-[#a3d977] transition-colors" data-id="element-439">
              Blog
            </Link>
            <Link to="/proof" className="hover:text-[#a3d977] transition-colors" data-id="element-440">
              Proof
            </Link>
            <Link to="/contact" className="text-white font-bold" data-id="element-441">
              Contact
            </Link>
          </div>
          <p data-id="element-442">
            &copy; {new Date().getFullYear()} Northwest Black Belt Academy. All
            rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}